/* eslint-disable import/no-anonymous-default-export */
import Workflows from "./Workflows";
import Placeholders from "./Placeholders";
export default {
    id: 110,
    title: 'Delegated Actions',
    path: 'delegated-actions',
    icon: "flaticon2-group",
    workflows: Workflows,
    placeholders: Placeholders,
};